import { environment } from '../../../environments/environment';

/** Base URL da API (definida em .env por ambiente). */
export const API_BASE = environment.baseUrl;
